import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react';

type CommentCardProps = {
    senderName: string;
    sentDate: string;
    comment: string;
    isMine?: boolean;
}

const CommentCard = ({
    comment,
    senderName,
    sentDate,
    isMine
}: CommentCardProps) => {
    const bgColor = useColorModeValue(
        isMine ? "gray.200" : "main.100",
        isMine ? "gray.600" : "main.400"
    );
    return (
        <Flex my={2} width="full" justifyContent={isMine ? 'flex-end' : 'flex-start'}>
            <Box
                width="max-content"
                p={3}
                rounded="xl"
                bg={bgColor}
                borderTopLeftRadius={isMine ? undefined : 0}
                borderTopRightRadius={isMine ? 0 : undefined}
            >
                <HStack alignItems="flex-end" lineHeight={1}>
                    <Text fontWeight="bold" >{senderName}</Text>
                    <Text fontSize="xs" ml={4} color="muted.400">{sentDate}</Text>
                </HStack>
                <HStack justify={isMine ? "flex-end" : "flex-start"}>
                    <Text w="70%" textAlign={isMine ? 'right' : 'left'} my={2}>{comment}</Text>
                </HStack>
            </Box>
        </Flex>
    )
}

export default CommentCard